import {
  Component,
  ChangeDetectionStrategy
} from '@angular/core';


export class SkyFilterSummaryComponent {
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-filter-summary',
  styles: [`.sky-filter-summary-header {
  margin-right: 10px;
  font-weight: 600;
}

.sky-filter-summary {
  background-color: #ffffff;
  overflow-x: auto;
  display: flex;
  align-items: center;
}

.sky-filter-summary-items {
  white-space: nowrap;
}
`],
  template: `<div class="sky-filter-summary">
  <span class="sky-filter-summary-header">{{'filter_summary_header' | skyResources}}:</span>
  <div class="sky-filter-summary-items">
      <ng-content></ng-content>
  </div>
</div>
`,
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
